export default __webpack_public_path__ + "b02f526e061120998829bcfb18f047a6.png";